import type * as lazyIndex from './lazyIndex';
import { type LazyComponent, LazyModule, createLazyComponent } from 'owa-bundling';
import type { PstTasksListProps } from './components/PstTasksList';

// Lazy module for PST Tasks view
const lazyLoadPstTasksView: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "PstTasksView" */ './lazyIndex'),
    {
        name: 'PstTasksView',
    }
);

// Lazy component for the PST Tasks list
export const LazyPstTasksList: LazyComponent<PstTasksListProps, unknown, void> =
    createLazyComponent(lazyLoadPstTasksView, m => m.PstTasksList);

// Direct exports for non-lazy usage
export { default as shouldShowPstTasks } from './selectors/shouldShowPstTasks';
export type { PstTasksListProps } from './components/PstTasksList';

// Export the initialization function
export { initializePstTasksOrchestrators } from './orchestrators/initializePstTasksOrchestrators';
